"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _constants = require("@seedlang/constants");
var _stores = require("@seedlang/stores");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ConjugationCardWrapper = function ConjugationCardWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "multipleChoiceSelected", _descriptor, _this);
      _initializerDefineProperty(_this, "correct", _descriptor2, _this);
      _initializerDefineProperty(_this, "randomTenseConceptId", _descriptor3, _this);
      _initializerDefineProperty(_this, "randomPronoun", _descriptor4, _this);
      _initializerDefineProperty(_this, "showAccentWarning", _descriptor5, _this);
      _initializerDefineProperty(_this, "showMultipleWordsWarning", _descriptor6, _this);
      _initializerDefineProperty(_this, "clickedAnswer", _descriptor7, _this);
      _this.randomPronoun = (0, _lodash.shuffle)(['singular_1p', 'singular_2p', 'singular_3p', 'plural_1p', 'plural_2p', 'plural_3p'])[0];
      _this.randomTenseConceptId = (0, _lodash.shuffle)(Object.keys(_constants.Constants.GRAMMAR_TENSES[_this.props.card.word.languageId || _this.props.card.languageId || 'DE']))[0];
      _this.loadConcept();
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "revealed",
      get: function get() {
        return this.props.cardState.revealed;
      }
    }, {
      key: "tenseConceptId",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card.tenseConceptId) ? this.props.card.tenseConceptId : this.randomTenseConceptId; // german present tenses
      }
    }, {
      key: "loadConcept",
      value: function loadConcept() {
        if ((0, _utils.isPresent)(this.tenseConceptId) && (!_stores.ConceptStore.hasShowData || _stores.ConceptStore.showData.id !== this.tenseConceptId)) {
          _stores.ConceptStore.getShow({
            ids: {
              conceptId: this.tenseConceptId
            }
          });
        }
      }
    }, {
      key: "pronoun",
      get: function get() {
        return (0, _utils.isPresent)(this.props.card.pronoun) ? this.props.card.pronoun : this.randomPronoun;
      }
    }, {
      key: "pronounField",
      get: function get() {
        return this.pronoun.replace('_', '');
      }
    }, {
      key: "isPastPerfect",
      get: function get() {
        return this.props.card.word.languageId === 'DE' && this.tenseConceptId === 'c1e9f360-b6d3-422b-bde4-1ad86deb466a' || this.props.card.word.languageId === 'FR' && this.tenseConceptId === '1dc1f99d-c766-4c2c-9f8e-0219c6b28b21';
      }
    }, {
      key: "buttonOptions",
      get: function get() {
        var _this$props$card,
          _options,
          _DeckUI$targetLanguag,
          _this2 = this;
        if (this.isPastPerfect && (this.props.card.word.languageId === 'DE' || ((_this$props$card = this.props.card) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.word) === null || _this$props$card === void 0 || (_this$props$card = _this$props$card.level) === null || _this$props$card === void 0 ? void 0 : _this$props$card.position) > 1)) {
          return this.pastPerfectOptions;
        }
        var options = [];
        (_options = options).push.apply(_options, _toConsumableArray(this.randomOptionsFromTense));
        if (((_DeckUI$targetLanguag = _state.DeckUI.targetLanguage.level) === null || _DeckUI$targetLanguag === void 0 ? void 0 : _DeckUI$targetLanguag.position) > 1 || options.length < 3) {
          var _options2;
          (_options2 = options).push.apply(_options2, _toConsumableArray(this.randomOptionsFromPronoun));
        }
        options = (0, _lodash.shuffle)((0, _lodash.uniq)(options.filter(function (item) {
          return _this2.conjugatedVerbStringDisplayValue(item) !== _this2.conjugatedVerbStringDisplayValue(_this2.correctAnswer) && _this2.conjugatedVerbStringDisplayValue(item) !== _this2.conjugatedVerbStringDisplayValue(_this2.correctAnswerFromConjugatedVerbString);
        })));
        if (options.length >= 3) {
          options = options.slice(0, 3);
        } else {
          options = options.slice(0, 1);
        }
        options.push(this.correctAnswer);
        return (0, _lodash.shuffle)(options).map(function (item, index) {
          return {
            id: index,
            value: item,
            displayValue: _this2.conjugatedVerbStringDisplayValue(item)
          };
        });
      }
    }, {
      key: "pastPerfectOptions",
      get: function get() {
        var _this3 = this;
        if (!this.correctAnswer) {
          return [];
        }
        if (!(this.props.card.word.languageId === 'DE' && this.tenseConceptId === 'c1e9f360-b6d3-422b-bde4-1ad86deb466a') && !(this.props.card.word.languageId === 'FR' && this.tenseConceptId === '1dc1f99d-c766-4c2c-9f8e-0219c6b28b21')) {
          return [];
        }
        if (this.props.card.word.languageId === 'DE') {
          var otherVerb,
            middle = '';
          var auxOptions = {
            singular_1p: ['bin', 'habe'],
            singular_2p: ['bist', 'hast'],
            singular_3p: ['ist', 'hat'],
            plural_1p: ['sind', 'haben'],
            plural_2p: ['seid', 'habt'],
            plural_3p: ['sind', 'haben']
          };
          var aux = this.correctAnswer.split(' ')[0];
          var verb = (0, _lodash.last)(this.correctAnswer.split(' '));
          if (verb.slice(-2) === 'ten') {
            otherVerb = verb.slice(0, verb.length - 2);
          } else if (otherVerb = verb.slice(-2) === 'et') {
            otherVerb = "".concat(verb.slice(0, verb.length - 1), "n");
          } else if (otherVerb = verb.slice(-1) === 't') {
            otherVerb = "".concat(verb.slice(0, verb.length - 1), "en");
          } else {
            otherVerb = "".concat(verb.slice(0, verb.length - 2), "t");
          }
          if (this.correctAnswer.split(' ').length > 2) {
            middle = "".concat(this.correctAnswer.split(' ')[1], " ");
          }
          var otherAux = aux.slice(0, 1) === 'h' ? auxOptions[this.pronoun][0] : auxOptions[this.pronoun][1];
          var options = ["".concat(aux, " ").concat(middle).concat(verb), "".concat(otherAux, " ").concat(middle).concat(verb), "".concat(aux, " ").concat(middle).concat(otherVerb), "".concat(otherAux, " ").concat(middle).concat(otherVerb)];
          return options.sort().map(function (item, index) {
            return {
              id: index,
              displayValue: item,
              value: item
            };
          });
        }
        if (this.props.card.word.languageId === 'FR') {
          var _otherVerb = '';
          var beginning = '';
          var _aux = '';
          var _auxOptions = {
            singular_1p: ['ai', 'suis'],
            singular_2p: ['as', 'es'],
            singular_3p: ['a', 'est'],
            plural_1p: ['avons', 'sommes'],
            plural_2p: ['avez', 'êtes'],
            plural_3p: ['ont', 'sont']
          };
          if (this.correctAnswer.split(' ').length > 2) {
            beginning = "".concat(this.correctAnswer.split(' ')[0], " ");
            _aux = this.correctAnswer.split(' ')[1];
          } else {
            _aux = this.correctAnswer.split(' ')[0];
          }
          var _verb = (0, _lodash.last)(this.correctAnswer.split(' '));
          var wrongEndings = ['é', 'u', 'i'].filter(function (ending) {
            return ending !== (0, _lodash.deburr)(_verb).slice(-1) && ending !== _verb.slice(-1);
          });
          if (_verb.match(/é(e*s*)$/)) {
            _otherVerb = _verb.replace(/é(?=e*s*$)/, 'u');
          } else if (_verb.match(/u(e*s*)$/)) {
            _otherVerb = _verb.replace(/u(?=e*s*$)/, 'é');
          } else if (_verb.match(/i(e*s*)$/)) {
            _otherVerb = _verb.replace(/i(?=e*s*$)/, 'é');
          } else {
            var randomInt = (0, _lodash.random)(0, 1);
            _otherVerb = _verb.slice(0, -1) + wrongEndings[randomInt];
          }
          var _otherAux = ['a', 'o'].includes(_aux.slice(0, 1)) ? _auxOptions[this.pronoun][1] : _auxOptions[this.pronoun][0];
          var _options3 = ["".concat(beginning).concat(_aux, " ").concat(_verb), "".concat(beginning).concat(_otherAux, " ").concat(_verb), "".concat(beginning).concat(_aux, " ").concat(_otherVerb), "".concat(beginning).concat(_otherAux, " ").concat(_otherVerb)];
          return _options3.sort().map(function (item, index) {
            return {
              id: index,
              value: item,
              displayValue: _this3.conjugatedVerbStringDisplayValue(item.replace(/e ([aoe])/, '\'$1'))
            };
          });
        }
      }
    }, {
      key: "icons",
      get: function get() {
        var _this$props$card$conc;
        if (this.showWordCard) {
          return [];
        }
        var ary = [];
        if (!this.props.cardState.revealed && this.props.card.cardType.slug !== 'conjugation-fill-in-blanks' && this.props.card.cardType.slug !== 'conjugation-multiple-choice') {
          ary.push('toggleMultipleChoice');
        }
        if ((0, _utils.isPresent)(this.props.card.grammarTip)) {
          ary.push('grammarTip');
        }
        if (_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('reviewDetails');
        }
        if (!_state.DeckUI.reviewDeck && this.props.cardState.revealed) {
          ary.push('toggleReview');
        }
        if (this.props.cardState.revealed && (0, _utils.isPresent)(this.props.card.tenseConceptId) && (_this$props$card$conc = this.props.card.concept) !== null && _this$props$card$conc !== void 0 && _this$props$card$conc.longDescriptionMd) {
          ary.push('tenseDescription');
        }
        if (this.props.cardState.revealed) {
          ary.push('cardComments');
        }
        if (_state.DeckUI.reviewDeck && (this.props.cardState.revealed || this.props.card.showNoteBeforeReveal)) {
          ary.push('cardNote');
        }
        return ary;
      }
    }, {
      key: "conjugatedVerbStringDisplayValue",
      value: function conjugatedVerbStringDisplayValue(value) {
        if (value && this.isReflexiveVerb) {
          var _this$props$card$word;
          return (0, _utils.displayTargetTextCorrectedForLanguage)(value.split(/ |'/).filter(function (item) {
            return (0, _utils.isPresent)(item);
          }).slice(1).join(' '), (_this$props$card$word = this.props.card.word) === null || _this$props$card$word === void 0 ? void 0 : _this$props$card$word.languageId);
        } else if (value) {
          var _this$props$card$word2;
          return (0, _utils.displayTargetTextCorrectedForLanguage)(value.trim(), (_this$props$card$word2 = this.props.card.word) === null || _this$props$card$word2 === void 0 ? void 0 : _this$props$card$word2.languageId);
        }
        return '';
      }
    }, {
      key: "randomOptionsFromPronoun",
      get: function get() {
        var _this$props$card2,
          _this4 = this;
        if (!((_this$props$card2 = this.props.card) !== null && _this$props$card2 !== void 0 && (_this$props$card2 = _this$props$card2.word) !== null && _this$props$card2 !== void 0 && _this$props$card2.conjugatedVerbStrings)) {
          return;
        }
        var options = this.props.card.word.conjugatedVerbStrings.map(function (item) {
          return item[_this4.pronounField];
        });
        var displayOptions = options.map(function (item) {
          return _this4.conjugatedVerbStringDisplayValue(item);
        });
        options = options.filter(function (item, index) {
          return displayOptions.indexOf(_this4.conjugatedVerbStringDisplayValue(item)) === index;
        });
        return options;
      }
    }, {
      key: "randomOptionsFromTense",
      get: function get() {
        var _this$props$card3,
          _this5 = this;
        if (!((_this$props$card3 = this.props.card) !== null && _this$props$card3 !== void 0 && (_this$props$card3 = _this$props$card3.word) !== null && _this$props$card3 !== void 0 && _this$props$card3.conjugatedVerbStrings)) {
          return;
        }
        var conjugatedVerbString = this.props.card.word.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === _this5.tenseConceptId;
        });
        if (conjugatedVerbString) {
          var options = [conjugatedVerbString['singular1p'], conjugatedVerbString['singular2p'], conjugatedVerbString['singular3p'], conjugatedVerbString['plural1p'], conjugatedVerbString['plural2p'], conjugatedVerbString['plural3p']];
          var displayOptions = options.map(function (item) {
            return _this5.conjugatedVerbStringDisplayValue(item);
          });
          options = options.filter(function (item, index) {
            return displayOptions.indexOf(_this5.conjugatedVerbStringDisplayValue(item)) === index;
          });
          return options;
        }
      }
    }, {
      key: "correctConjugatedVerbString",
      get: function get() {
        var _this6 = this;
        return this.props.card.word.conjugatedVerbStrings.find(function (item) {
          return item.conceptId === _this6.tenseConceptId;
        });
      }
    }, {
      key: "correctAnswer",
      get: function get() {
        var _this$props$card$sent;
        if ((0, _utils.isPresent)((_this$props$card$sent = this.props.card.sentence) === null || _this$props$card$sent === void 0 ? void 0 : _this$props$card$sent.targetText)) {
          return this.props.card.sentence.targetText.trim().replace(/(\.\.\.|…)/, '').split(' ').slice(1).join(' ');
        }
        return this.correctAnswerFromConjugatedVerbString;
      }
    }, {
      key: "correctAnswerFromConjugatedVerbString",
      get: function get() {
        if (this.correctConjugatedVerbString) {
          return this.correctConjugatedVerbString[this.pronoun.replace('_', '')].replace(/'/, '\' ').replace(/\s+/, ' ');
        }
      }
    }, {
      key: "correctAnswers",
      get: function get() {
        if (this.isPastPerfect && this.props.card.word.languageId === 'FR') {
          return (0, _lodash.flatten)([this.correctAnswer, this.frenchPerfectCorrectAnswers]);
        }
        return [this.correctAnswer];
      }
    }, {
      key: "frenchPerfectCorrectAnswers",
      get: function get() {
        var correctAnswers = [];
        if (/\b(me|te)*\s*(suis|es)\b/.test(this.correctAnswer)) {
          if (this.correctAnswer.endsWith('e')) {
            correctAnswers.push(this.correctAnswer.replace(/e$/, ''));
          } else {
            correctAnswers.push("".concat(this.correctAnswer, "e"));
          }
        }
        if (/\b(nous|vous)*\s*(sommes|êtes)\b/.test(this.correctAnswer)) {
          if (this.correctAnswer.endsWith('es')) {
            correctAnswers.push(this.correctAnswer.replace(/es$/, 's'));
          } else {
            correctAnswers.push(this.correctAnswer.replace(/s$/, 'es'));
          }
        }
        return correctAnswers;
      }
    }, {
      key: "textInputWithoutPronoun",
      get: function get() {
        var _this$props$card4, _pronounPattern;
        // users sometimes erroneously add the pronoun in the text input
        var textInput = this.props.cardState.textEntry;
        var pronounString = _constants.Constants.PRONOUN_STRINGS[((_this$props$card4 = this.props.card) === null || _this$props$card4 === void 0 || (_this$props$card4 = _this$props$card4.word) === null || _this$props$card4 === void 0 ? void 0 : _this$props$card4.languageId) || 'DE'][this.pronoun].split(',')[0];
        var parenthesesPattern = new RegExp('\s\(.+\)');
        var pronounPattern;
        if (parenthesesPattern.test(pronounString)) {
          pronounPattern = new RegExp("^(".concat(pronounString, "|").concat(pronounString.replace(parenthesesPattern, ''), ")\\s"));
        } else {
          pronounPattern = new RegExp("^".concat(pronounString, "\\s"));
        }
        if ((_pronounPattern = pronounPattern) !== null && _pronounPattern !== void 0 && _pronounPattern.test(textInput)) {
          textInput = textInput.replace(pronounPattern, '');
        }
        return textInput;
      }
    }, {
      key: "textInputIsCorrect",
      get: function get() {
        var _this7 = this;
        var textInputVersions = (0, _lodash.uniq)([this.props.cardState.textEntry, this.textInputWithoutPronoun]);
        return (0, _lodash.some)((0, _lodash.flatten)(textInputVersions.map(function (textInput) {
          return (0, _lodash.flatten)(_this7.correctAnswers.map(function (correctAnswer) {
            return _this7.normalizeAndCompare(textInput, correctAnswer.toLowerCase());
          }));
        })));
      }
    }, {
      key: "normalizeAndCompare",
      value: function normalizeAndCompare(stringA, stringB) {
        return _state.DeckUI.normalizeString(stringA) === _state.DeckUI.normalizeString(stringB);
      }
    }, {
      key: "textInputIsCorrectWithoutAccent",
      get: function get() {
        return !this.textInputIsCorrect && (0, _lodash.deburr)(_state.DeckUI.normalizeString(this.props.cardState.textEntry)) === (0, _lodash.deburr)(_state.DeckUI.normalizeString(this.correctAnswer.toLowerCase()));
      }
    }, {
      key: "textInputIsMissingWords",
      get: function get() {
        return this.correctAnswer && this.correctAnswer.match(' ') && (0, _utils.isPresent)(this.props.cardState.textEntry) && this.props.cardState.textEntry.split(/(\s+|'|’)/).length < this.correctAnswer.toString().split(/\s+/).length;
      }
    }, {
      key: "isReflexiveVerb",
      get: function get() {
        return this.props.card.word.languageId === 'FR' && /^s[e']\b/.test(this.props.card.word.targetText) || this.props.card.word.languageId === 'ES' && this.props.card.word.targetText.endsWith('se');
      }
    }, {
      key: "onTextInputChange",
      value: function onTextInputChange(val) {
        _state.DeckUI.onWordInputChange(this.props.cardState, val);
        this.showAccentWarning = false;
        if (_state.DeckUI.user.evaluateVocabOnKeystroke && this.textInputIsCorrect) {
          this.handleCorrectAnswer();
        } else if (_state.DeckUI.user.evaluateVocabOnKeystroke && this.textInputIsCorrectWithoutAccent) {
          this.showAccentWarning = true;
        } else if (_state.DeckUI.user.evaluateVocabOnKeystroke && !this.textInputIsCorrectWithoutAccent) {
          this.showAccentWarning = false;
        }
      }
    }, {
      key: "evaluateTextInput",
      value: function evaluateTextInput() {
        if (this.textInputIsCorrect) {
          this.handleCorrectAnswer();
        } else if (this.textInputIsCorrectWithoutAccent && !this.showAccentWarning) {
          this.showAccentWarning = true;
        } else if (this.textInputIsMissingWords && !this.showMultipleWordsWarning) {
          this.showMultipleWordsWarning = true;
        } else {
          this.handleIncorrectAnswer();
        }
      }
    }, {
      key: "handleCorrectAnswer",
      value: function handleCorrectAnswer() {
        var _this8 = this;
        this.correct = true;
        this.props.userCard.set('score', 1);
        _state.DeckUI.onCorrectAnswer(this.props.card, this.props.cardState, this.props.userCard, {
          xp: 1,
          xpSlug: 'conjugation'
        });
        setTimeout(function () {
          return _state.DeckUI.reveal(_this8.props.card, _this8.props.cardState);
        }, 500);
      }
    }, {
      key: "handleIncorrectAnswer",
      value: function handleIncorrectAnswer() {
        var _this9 = this;
        this.props.userCard.set('seen', true);
        _state.DeckUI.onIncorrectAnswer(this.props.card, this.props.cardState, this.props.userCard);
        setTimeout(function () {
          return _state.DeckUI.reveal(_this9.props.card, _this9.props.cardState);
        }, 500);
      }
    }, {
      key: "onClickButton",
      value: function onClickButton(option) {
        this.clickedAnswer = this.conjugatedVerbStringDisplayValue(option.value);
        if (!_state.DeckUI.user.wasUiElementSeen('conjugation-multiple-choice')) {
          _state.DeckUI.designateUiElementAsSeen('conjugation-multiple-choice');
        }
        this.multipleChoiceSelected = option.id;
        if (option.value === this.correctAnswer) {
          this.handleCorrectAnswer();
        } else {
          this.handleIncorrectAnswer();
        }
        setTimeout(this.clearSelection, 500);
      }
    }, {
      key: "clearSelection",
      value: function clearSelection() {
        this.multipleChoiceSelected = null;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          buttonOptions: this.buttonOptions,
          correctAnswer: this.correctAnswer,
          onClickButton: this.onClickButton,
          multipleChoiceSelected: this.multipleChoiceSelected,
          revealed: this.revealed,
          correct: this.correct,
          onTextInputChange: this.onTextInputChange,
          evaluateTextInput: this.evaluateTextInput,
          showAccentWarning: this.showAccentWarning,
          icons: this.icons,
          showMultipleWordsWarning: this.showMultipleWordsWarning,
          pronoun: this.pronoun,
          tenseConceptId: this.tenseConceptId,
          clickedAnswer: this.clickedAnswer,
          isReflexiveVerb: this.isReflexiveVerb,
          showTextEntryCard: this.showTextEntryCard
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "multipleChoiceSelected", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "correct", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "randomTenseConceptId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "randomPronoun", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "showAccentWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "showMultipleWordsWarning", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "clickedAnswer", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "revealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "revealed"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "tenseConceptId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "tenseConceptId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadConcept", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadConcept"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pronounField", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pronounField"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isPastPerfect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isPastPerfect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "buttonOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "buttonOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "pastPerfectOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "pastPerfectOptions"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "icons", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "conjugatedVerbStringDisplayValue", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "conjugatedVerbStringDisplayValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "randomOptionsFromPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "randomOptionsFromPronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "randomOptionsFromTense", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "randomOptionsFromTense"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctConjugatedVerbString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctConjugatedVerbString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswerFromConjugatedVerbString", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswerFromConjugatedVerbString"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "correctAnswers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "correctAnswers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "frenchPerfectCorrectAnswers", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "frenchPerfectCorrectAnswers"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputWithoutPronoun", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputWithoutPronoun"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsCorrect", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsCorrect"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "normalizeAndCompare", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "normalizeAndCompare"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsCorrectWithoutAccent", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsCorrectWithoutAccent"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputIsMissingWords", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputIsMissingWords"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "isReflexiveVerb", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "isReflexiveVerb"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onTextInputChange", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onTextInputChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "evaluateTextInput", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "evaluateTextInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleCorrectAnswer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleCorrectAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "handleIncorrectAnswer", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "handleIncorrectAnswer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onClickButton", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onClickButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearSelection", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "clearSelection"), _class2.prototype), _class2)) || _class;
};
ConjugationCardWrapper.displayName = 'ConjugationCardWrapper';
var _default = exports["default"] = ConjugationCardWrapper;